import styled from 'styled-components';

import { COLORS } from '@theme/colors';
import { CONTAINER_PADDING } from '@components/blocks/blocks.constants';
import { containerStyles, paragraphStyles, paragraphTextStyles } from '@components/blocks/blocks.styles';
import { media } from '@theme/media';
import { FONT_SIZE } from '@theme/font';

export const BottomArrow = styled.i`
  transition: transform 0.5s ease-in-out;
  margin-right: 5px;
  display: inline-block;

  &:before {
    content: '↓';
    font-size: ${FONT_SIZE.XS};
  }
`;

export const Copy = styled.span`
  transition: border 0.25s ease-in-out;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

export const Container = styled.div`
  cursor: pointer;
  ${paragraphTextStyles};

  &:hover ${Copy} {
    border-color: ${COLORS.BLACK};
  }

  &:hover ${BottomArrow} {
    transform: rotate(360deg);
  }
`;

export const ButtonContainer = styled.div`
  padding: ${CONTAINER_PADDING * 3}px 0;
  ${containerStyles};
  ${paragraphStyles};
  padding-bottom: ${CONTAINER_PADDING * 3}px;
  margin: -18px auto 0;

  ${media.mobile} {
    margin: -52px auto 0;
  }
`;
